/** Formats a number as a money string, like 1000 to $1,000 */
export const formatMoney = (value: number | null) =>
  value ? `$${new Intl.NumberFormat().format(value)}` : '';

/** Generates age range string */
export const getAgeString = ({
  minAge,
  maxAge,
}: {
  minAge: number | null;
  maxAge: number | null;
}): string | null => {
  /** If both min and max age are present, return the range like "18 - 25" */
  if (minAge && maxAge) {
    return `${minAge} - ${maxAge}`;
  }

  /** If only min age is present, return "18+" */
  if (minAge) {
    return `${minAge}+`;
  }

  /** If only max age is present, return "Up to 25" */
  if (maxAge) {
    return `Up to ${maxAge}`;
  }

  return null;
};

/** Formats award range as a currency range */
export const formatCurrencyRange = ({
  min,
  max,
}: {
  min: number | null;
  max: number | null;
}): string | null => {
  /** If we have both min and max, return it as e.g., "$1,000 - $5,000" */
  if (min && max) {
    return `${formatMoney(min)} - ${formatMoney(max)}`;
  }

  /** If we have only min, return just the minimum */
  if (min) {
    return formatMoney(min);
  }

  /** If we have only max, return just the maximum */
  if (max) {
    return formatMoney(max);
  }

  /** If we have neither, return null */
  return null;
};
